<template>
  <a-button
    size="large"
    class="mt-5"
    @click="loadWatchface"
    @focus="(e:UIEvent)=>{(e.target as HTMLElement).blur();}"
  >
    加载本地表盘
  </a-button>

  <!-- 表盘导出成功页面 -->
  <ModalExportSuccess ref="exportSuccessRef" />
</template>

<script setup lang="ts">
import { useWatchfaceHistory } from '@/hooks';
import { ElectronApi } from '@/services/electron.api';
import { pickDir } from '@/utils/fs/pick-file.utils';
import { validWatchfaceDir } from '@/utils/watchface-valid.utils';

const { addItem } = useWatchfaceHistory();

const loadWatchface = async () => {
  const { fs, path } = ElectronApi;
  if (!fs || !path) return;
  const dir = await pickDir();
  if (!dir) return;
  const files = await fs.promises.readdir(dir);
  for (const file of files) {
    const filePath = path.join(dir, file);
    const valid = validWatchfaceDir(filePath).catch(() => false);
    if (!valid) continue;
    addItem(filePath);
  }
};
</script>
